import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { AppCommonService } from '../appcommon.service';
import { IBlog, IDriverClubNews } from '../blogs/blog';
import { BlogService } from '../blogs/blog.service';

@Component({
  selector: 'mft-relateddriversclubnews',
  templateUrl: "./relateddriversclubnews.component.html"
})
export class RelatedDriversClubNewsComponent implements OnInit, AfterViewInit {
  @Input() newsList: IDriverClubNews[];
  @Input() dtitle: string;
  constructor(private authService: AuthService,
    private appCommonService: AppCommonService,
    private router: Router,
    public blogService: BlogService,
  ) {

  }
  ngOnInit() {

  }

  ngAfterViewInit() {

  }
}



// WEBPACK FOOTER //
// ./src/app/genericpages/relateddriversclubnews.component.ts